//产品管理上传文件
import service from "@/utils/axios";

// 设备管理左侧树
export const getDeviceTree = (params) => service.post('/meta/device/getDeviceTree',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// 设备管理列表
export const getDevicePage = (params) => service.post('/meta/device/getDevicePage',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
//按状态统计设备数量
export const getDeviceCountByStatus = (params) => service.post('/meta/device/count/status', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// 修改电站的设备名称
export const changeDeviceName = (params) => service.put('/meta/device/changeDeviceName',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// 修改电站下采集器名称
export const changeDataLogName = (params) => service.put('/meta/datalog/changeDataLogName',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 产品名称列表
// export const getAllProductName = (params) => service.post('/meta/device/list/getProduct',  params ,{
//   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
// });
// 产品名称列表NEW
export const getAllProductName = (params) => service.get('/meta/device/list/getProductSeries', { params });
// 根据产品名称查询产品型号列表
export const getProductModels = (params) => service.get('/meta/device/list/getProductModels', { params });
// 安装商列表
export const getAllSysDeptList = (params) => service.post('/meta/device/getAllSysDeptList',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 获取设备运行数据接口
export const getRunningData = (params) => service.post('/meta/device/detail/getRunningData',   params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 设备基础信息接口
export const getDeviceInfo = (params) => service.post('/meta/device/detail/getDeviceInfo',   params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 设备详情接口
export const getEnergyAnalyzer = (params) => service.post('/meta/device/detail/getEnergyAnalyzer',   params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 获取参数控制列表 /meta/device/control/param-definitions?deviceSn=1033050238230005'
export const getDeviceParams = (params) => service.get('/meta/device/control/param-definitions', { params });

// 读取锦浪服务的参数数据
export const getDeviceParamValue = (params) => service.post('/meta/device/control/read/batch/param-setting', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 直接读取数据库缓存的锦浪参数数据 device/control/get/param-settings?deviceSn=1031110243160013
// export const getDeviceParamSetting = (params) => service.post('/meta/device/control/get/param-settings', params, {
//   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
// });
export const getDeviceParamSetting = (params) => service.get(`/meta/device/control/get/param-settings?deviceSn=${params.deviceSn}`);

/**
 * 单个数据从设备端直接读取 /device/control/read/single/param-setting
 * @param {*} params
 * deviceSn 设备编号
 * cid 参数编码
 * dpid 参数编码
 * code 参数编码
 * accessPlatform 访问平台 0 老平台 1 青络iot平台
 * @returns 
 */
export const readControlParam = (params) => service.post('/meta/device/control/read/single/param-setting', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// export const readControlParam = (params) => service.get('/meta/device/control/read/single/param-setting', { params });

// 参数下发 /device/control/control/single/param-setting
export const controlParamSetting = (params) => service.post('/meta/device/control/control/single/param-setting', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 参数下发 /device/control/control/batch/param-setting
export const controlBatchParamSetting = (params) => service.post('/meta/device/control/control/batch/param-setting', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  timeout: 30000  // 单个接口超时配置
});

// 查询是否是新设备 /device/control/control/query/solis/6798/{BdeviceSn}
export const querySolis = (params) => service.get(`/meta/device/control/control/query/solis/6798/${params.deviceSn}`);

// 导出历史数据
// export const exportExcle = (params) => service.post('/admin/excel/export', params);

// 导出历史数据新
export const exportExcle = (params) => service.post('/meta/device/detail/exportDeviceInfo', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  responseType: "blob"
});

// 运行数据分析接口 /device/detail/getRunningDataAnalyzer
export const getRunningDataAnalyzer = (params) => service.post('/meta/device/detail/getRunningDataAnalyzer', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 运行数据树结构 /device/detail/getRunningDataTreeList
export const getRunningDataTreeList = (params) => service.post('/meta/device/detail/getRunningDataTreeList', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 源网荷储 更多信息
// device/getDeviceBySn?type=11&sn=D0M00005FQCK0001&time=2024-12-12&deviceType=65323
// deviceType sn type time
export const getDeviceBySn = (params) => service.get(`/meta/device/getDeviceBySn`, { params });

// 获取故障、告警信息 /msg/getMsgPage
// "pageNo": 2,
// "pageSize": 15,
// "msgType": "2",
// "deviceSn": "D0M00005FQCK0001",
// "faultType": 0
export const getMsgPage = (params) => service.post('/meta/msg/getMsgPage', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

//  设备详情接口
export const getAdminDeviceInfo = (params) => service.post('/meta/device/detail/getAdminDeviceInfo', params,
  {  headers: { 'Content-Type': 'application/json;charset=UTF-8' },}
);//引入qs模块，用来序列化post类型的数据

export const getUserEmailBySearch = (params) => service.post('/admin/agent/getUserEmailBySearch', params);
/**
 * 透传读单个设备参数 Modbus 03
 * @method post
 * @param deviceSn
 * @param deviceType
 * @param startAddr
 * */
export const getDeviceData = (params) => service.post('/meta/device/getDeviceData', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);

/**
 *透传写多个设备参数 Modbus 10
 * @method post
 * @param
 * */
export const setDeviceData = (params) => service.post('/meta/device/setDeviceData', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);

// 阳台1.0 2.0 3.0 设备参数读取接口
export const getSettingInfo = (params) => service.get('/meta/device/getSettingInfo', { params });

// 阳台1.0 2.0 3.0 设备参数设置接口
/**
 * 自定义设置设备参数
 * @param startAddr integer  必传
 * @param deviceSn  string  必传
 * @param deviceType integer  必传
 * @param datalogSn string  必传
 * @param  data {
 *    @param  test  string  参数名称（可变）
 * }
 */
export const setDeviceParam = (params) => service.post('/meta/device/setDeviceParam', params, 
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 自定义设置设备参数
 * @param startAddr integer  必传
 * @param deviceSn  string  必传
 * @param deviceType integer  必传
 * @param datalogSn string  必传
 * @param  data {
 *    @param  test  string  参数名称（可变）
 * }
 */
export const setDeviceParamHardware = (params) => service.post('/meta/device/setDeviceParam/hardware', params, 
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 阳台1.0 2.0 3.0 设备参数设置接口
/**
 * 自定义设置设备参数
 * @param deviceType integer  必传
 * @param deviceSn  string  必传
 * @param datalogSn string  必传
 * @param  object {
 *    @param  test  string  参数名称（可变）
 * }
 */

export const setCustomParams = (params) => service.post('/meta/device/setCustomParams', params, 
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 采集器更新（包括重启，重启也用这个接口）
 * @param datalogSn string  必传
 * @param startAddr integer  必传
 * @param dataValue 必传
 */
export const updateCollector = (params) => service.post('/meta/device/updateCollector', params, 
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 设置通讯棒域名
 * @param datalogSn string  必传
 * @param domainName string  必传
 */
export const setDomainName = (params) => service.post('/meta/device/setDomainName', params,  
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 采集器参数读取
 * @param datalogSn string  必传
 * @param startAddr integer  必传
 */
export const getDatalogParam = (params) => service.post('/meta/device/getDatalogParam', params, 
  {headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// 设备删除
export const DeleteDevices= (params) => service.post('/meta/device/delete',  params ,{
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
 
/**
 * 获取模块显示字段
 * @param type string  必传 50100
 */
export const getModuleDisplay = (params) => service.get('/base/module/display', { params });

// 获取采集器详情信息
export const getDataLogInfo = (params) => service.get(`/meta/datalog/getDataInfo/${params.datalogSn}`, { params });

// 查询设备是否开启了 动态电价功能
/**
 * @method get
 * @param plantId  必传
 * @param deviceSn  必传
 **/
// api/meta/price/isOpenAi?plantId=&deviceSn=
export const isOpenAi = (params) => service.get(`/meta/price/isOpenAi`, { params });

// 查询逆变器设备类型
/**
 * @method get
 * @param plantId  必传
 * @param deviceSn  必传
 **/
// api/meta/price/isOpenAi?plantId=&deviceSn=
export const queryAllType = (params) => service.get(`/base/device/type/queryByType?type=1`, { params });

// 查询逆变器设备更多基础信息
/**
 * @method get
 * @param deviceType  必传 目前仅支持 50000 贝瓦
 * @param sn  必传
 * @param type  默认传 0
 * @param time  传当日时间
 **/
// api/meta/price/isOpenAi?plantId=&deviceSn=
export const getDeviceBySnBaseInfoMore = (params) => service.get(`/meta/device/getDeviceBySnBaseInfoMore`, { params });

// 获取出货客户列表
/**
 * @method post
 * @param targetName  安装商名称（可选）
 **/
export const getCustomerList = (params) => service.post('/meta/device/customerList', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 查询iot逆变器设备的运行数据卡片
/**
 * @method post
 * @param deviceType  必传 目前仅支持 50000 贝瓦
 * @param deviceSn  必传
 **/
export const getRunningDataCard = (params) => service.post(`/meta/device/list/getRunningDataCard`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// IOT 告警列表 /open/device/get/alarm/1983450486530945024
export const getIOTAlarmList = (params) => service.get(`/meta/open/device/get/alarm/${params.deviceSn}`, { params });

/**
 * IOT 实时监控数据
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param groupId 分组 id（物模型 `expands.groupId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 * @param keyword 名称关键字（匹配原始 name 与 i18n 后 label）
 * @param pageNum 页码，默认 1
 * @param pageSize 每页条数，默认 20
 *  "groupTree": [
      { "id": "group_1", "label": "PCS_遥测", "children": [] },
      { "id": "group_2", "label": "电池", "children": [] }
    ],
    "list": [
      {
        "groupId": "group_1",
        "groupLabel": "PCS_遥测",
        "propertyId": "PCS_activePower_YC",
        "name": "系统输出功率",
        "description": "",
        "accessTypes": ["report"],
        "dataType": "float",
        "unit": "kW",
        "value": "12.3",
        "valueText": "12.3",
        "timestamp": 1768209660535
      },
]
 */
export const iotPropertyPage = (params) => service.post(`/meta/device/iot_property/page`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * IOT 导出属性实时数据表格（分页）
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param groupId 分组 id（物模型 `expands.groupId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 * @param keyword 名称关键字（匹配原始 name 与 i18n 后 label）
 * @param pageNum 页码，默认 1
 * @param pageSize 每页条数，默认 20
 * @reutrns 导出文件流
 */
export const iotPropertyPageExport = (params) => service.post(`/meta/device/iot_property/page/export`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  responseType: "blob",
  fullResponse: true
});

/**
 * IOT 刷新属性最新值
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 *  "propertyId": "systemRunningTime",
    "value": "2070666",
    "valueText": "2070666",
    "timestamp": 1768209660535
 */
export const iotPropertyRefresh = (params) => service.post(`/meta/device/iot_property/refresh_latest`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * IOT 查询属性历史数据表格（分页）
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 * @param pageNum 页码，默认 1
 * @param pageSize 每页条数，默认 20
 * @param startTime 开始时间（开始时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param endTime 结束时间（结束时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param flag 特殊标识：`24h`/`1d`/`3d`，存在则忽略 startTime/endTime
 *  "pageNum": 1,
    "pageSize": 10,
    "total": 33,
    "list": [
      { "time": "2026-01-13 05:35:00", "value": "0.0" },
      { "time": "2026-01-13 05:40:00", "value": "0.0" }
    ]
 */
export const iotPropertyHisTable = (params) => service.post(`/meta/device/iot_property/history/table`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * IOT 导出属性历史数据表格（全量，带保护）
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 * @param startTime 开始时间（开始时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param endTime 结束时间（结束时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param flag 特殊标识：`24h`/`1d`/`3d`，存在则忽略 startTime/endTime
 * @reutrns 导出文件流
 */
export const iotPropertyHisTableExport = (params) => service.post(`/meta/device/iot_property/history/table/export`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  responseType: "blob",
  fullResponse: true
});   

/**
 * IOT 查询属性历史数据图表（不聚合，最多15天）
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 * @param productId 产品 id（物模型 `expands.productId`）
 * @param plantTimeZone 时区（默认东八区）
 * @param startTime 开始时间（开始时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param endTime 结束时间（结束时间，格式 `yyyy-MM-dd HH:mm:ss` ）
 * @param flag 特殊标识：`24h`/`1d`/`3d`，存在则忽略 startTime/endTime
 *  "unitMap": {
      "室内目标温度": "℃"
    },
    "室内目标温度": {
      "05:30": 236.9,
      "05:35": 237.1,
      "05:40": 236.6
    }
 */
export const iotPropertyHisChart = (params) => service.post(`/meta/device/iot_property/history/chart`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * IOT 读取属性最新值
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 *  "data": {
        "code": "sustainedNegativeLoad",
        "value": 0,
        "yuanzhi": null,
        "updateTime": null
    }
*/ 
export const iotPropertyReadLatest = (params) => service.post(`/meta/device/iot_property/read_latest`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * IOT 给属性写值
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @param propertyId 属性 id（物模型 `expands.propertyId`）
 * @param value 属性值
*/ 
export const iotPropertyWriteProperty = (params) => service.post(`/meta/device/iot_property/write_property`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
// 获取设备导入模板下载地址
export const getDeviceImportTemplateUrl = (params) => service.get('/meta/deviceImportConfig/config/url', { params });

// 根据 MDM 物料编码查询产品信息
export const queryByMdm = (params) => service.get('/base/product/queryByMdm', { params });

// 导入设备文件解析
export const importDeviceFileAnalysis = (formData) => service.post('/meta/device/importFile/analysis', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

// 批量保存设备数据/meta/device/batch/building
export const batchBuilding = (params) => service.post('/meta/device/batch/building', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  timeout: 60000
});

// IOT 设备基础信息查询
/**
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @returns 
 * {
    "code": 200,
    "msg": "success",
    "data": {
        "sn": "1234567890",
        "iotProductId": "1234567890",
        "plantName": "产品名称",
        "ownerEmail": "设备名称",
        "productType": "设备类型",
        "productModel": "设备状态",
        "shipmentTime": "2026-01-13 05:35:00",
        "registerTime": "2026-01-13 05:40:00",
        "installer": "设备状态",
        "installerWorker": "1.0.0",
        "ownerReceiveDate": "2026-01-13 05:45:00",
        "ownerFamily": "设备状态"
    }
}
 */
export const iotBasicInfo = (params) => service.post('/meta/device/iot-basic-info/common/info', params, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

// 获取IOT的TSL物模型json数据信息 /api/meta/iot/getTSL?deviceType=''&deviceSn=''
export const getIOTTSL = (params) => service.get(`/meta/iot/getTSL`, { params });

/**
 * 批量写入设备属性
 * @method POST
 * @path /device/iot_property/write_properties
 * @description 批量下发多个属性到指定设备，调用 IoT 平台的 PUT /api/device/instance/{deviceSn}/property 接口
 * @param {Object} params
 * @param {string} params.deviceSn - 必传，设备SN（IoT平台 deviceId）
 * @param {Object} params.properties - 必传，属性键值对，key为propertyId，value为属性值
 * @returns {Object} 响应数据
 * @returns {number} response.code - 响应码，200表示成功
 * @returns {string} response.message - 响应消息
 * @returns {boolean} response.data - 下发结果，true表示成功
 * @example
 * // 请求示例
 * writeDeviceProperties({
 *   deviceSn: 'E-Tower-001',
 *   properties: {
 *     workMode: 1,
 *     selfUsedSoc: 80,
 *     economicModeSoc: 60,
 *     backupSoc: 20
 *   }
 * })
 * // 成功响应: { code: 200, message: 'success', data: true }
 * // 失败响应: { code: 500, message: '设备离线', data: false }
 * @throws {string} '设备离线' - 设备当前不在线，无法下发指令
 * @throws {string} '设备超时' - 设备响应超时
 * @throws {string} '不支持的操作' - 设备不支持该操作
 * @throws {string} '下发失败' - 其他下发失败情况
 * @note 批量下发时，所有属性会一次性发送到 IoT 平台；建议一次下发的属性数量不超过 20 个
 */
export const writeDeviceProperties = (params) => service.post('/meta/device/iot_property/write_properties', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * @param deviceSn 设备 SN（IoT 平台 deviceId）
 * @returns 
 * {
    "code": 200,
    "msg": "success",
    "data": [
      {
        "titleLabel": "51301.real.versionDemo01",
        "value": "1.0.0",
      },
      {
        "titleLabel": "51301.real.versionDemo02",
        "value": "1.0.0",
      },
      {
        "titleLabel": "51301.real.versionDemo03",
        "value": "1.0.0",
      }
    ]
}
 */
// 版本信息查询
export const versionInfo = (params) => service.post('/meta/device/iot-basic-info/version/info', params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 获取 E-Tower 3.0 配置说明
 * @method GET
 * @path /api/meta/advanced-function/config
 * @description 获取 E-Tower 3.0 设备的高级功能配置说明 JSON
 * @param {Object} params
 * @param {string} params.deviceType - 必传，设备类型（如：50901、50902）
 * @param {string} [params.deviceSn] - 可选，设备SN（目前未使用）
 * @returns {Object} 响应数据
 * @returns {number} response.code - 响应码，200表示成功
 * @returns {string} response.message - 响应消息
 * @returns {Object} response.data - 配置数据
 * @returns {Array} response.data.setting - 固定配置项列表，用于前端展示配置入口
 * @returns {Object} response.data.advanced-function - 高级功能配置
 * @returns {string} response.data.advanced-function.workMode - 工作模式配置 JSON
 * @returns {string} response.data.advanced-function.dryWorkingMode - 干节点工作模式配置 JSON
 * @example
 * // 请求示例
 * getEtower3Config({ deviceType: '50901' })
 * // 响应示例
 * {
 *   code: 200,
 *   message: 'success',
 *   data: {
 *     setting: [
 *       {
 *         id: 'dryWorkingMode',
 *         title: 'device.dryNodeSettings',
 *         description: 'device.dryNodeSettingsTip',
 *         buttonText: 'device.toSettings',
 *         icon: 'M19 3H5c-1.1...',
 *         gradient: 'linear-gradient(135deg, #4dabf7 0%, #339af0 100%)'
 *       }
 *     ],
 *     'advanced-function': {
 *       workMode: '{"id":"workMode","name":"工作模式","children":[...]}',
 *       dryWorkingMode: '{"id":"dryWorkingMode","name":"干节点工作模式","children":[...]}'
 *     }
 *   }
 * }
 * @note setting 字段为固定配置，用于前端展示配置入口；advanced-function 中的配置 JSON 从 advanced_func_template 表查询
 */
export const getAdvancedConfig = (params) => service.get('/meta/advanced-function/config', { params });

/**
 * 获取设备物模型（单位已转换）
 * @description 获取设备类型或设备的物模型，并将单位ID转换为单位符号（如 percent → %）
 * @param {Object} params - 请求参数
 * @param {string} [params.deviceType] - 设备类型（优先使用，与 deviceSn 二选一）
 * @param {string} [params.deviceSn] - 设备SN（deviceType 为空时使用，与 deviceType 二选一）
 * @returns {Promise<Object>} 响应数据
 * @returns {number} response.code - 响应码，200表示成功
 * @returns {string} response.message - 响应消息
 * @returns {string} response.data - 物模型 JSON 字符串（单位已转换）
 * @returns {string} response.timestamp - 响应时间戳
 * @returns {boolean} response.success - 是否成功
 * @example
 * // 使用 deviceType
 * iOTTSLWithUnit({ deviceType: '50901' })
 * 
 * // 使用 deviceSn
 * iOTTSLWithUnit({ deviceSn: 'E-Tower-001' })
 * 
 * // 同时传入（优先使用 deviceType）
 * iOTTSLWithUnit({ deviceType: '50901', deviceSn: 'E-Tower-001' })
 * @note
 * 1. 参数优先级: deviceType 优先于 deviceSn，如果同时传入，优先使用 deviceType
 * 2. 参数校验: deviceType 和 deviceSn 不能同时为空，至少传入一个
 * 3. 单位转换: 只转换能在单位映射表中找到的单位，找不到的保持原值
 * 4. 异常处理: 如果获取物模型失败或单位转换失败，会记录日志并返回原始物模型（如果有）
 * 5. 缓存机制: 单位映射关系会缓存 8 小时，物模型不缓存
 * 6. 返回格式: data 字段是 JSON 字符串，前端需要使用 `JSON.parse()` 解析
 * @see
 * 常见单位转换映射:
 * - percent → % (百分比)
 * - kilowatt → kW (千瓦)
 * - kilowatt-hour → kWh (千瓦时)
 * - celsius → ℃ (摄氏度)
 * - volt → V (伏特)
 * - ampere → A (安培)
 * - minutes → min (分钟)
 * - seconds → s (秒)
 */
export const iOTTSLWithUnit = (params) => service.post(`/meta/device/iot_property/tsl_with_unit`, params, {
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * @description 根据设备 SN 获取 PV 直流侧数据
 * @param {Object} params - 请求参数
 * @param {string} params.sn - 设备 SN
 * @param {number} params.deviceType - 设备类型
 * @param {number} [params.type=0] - 预留参数，当前该接口内部未实际使用
 * @param {string} params.time - 时间字符串，控制器要求必传
 * @returns {Promise} - 响应结果
 * @example
 * getDeviceBySnDcSide({
 *   sn: 'NH123456789',
 *   deviceType: 60419,
 *   type: 0,
 *   time: '2026-03-26 10:00:00'
 * })
 * @note
 * 1. 行数不是固定的，按产品配置的最大 PV 路数生成
 * 2. 如果产品未配置 PV 路数，rows 会返回空数组
 * 3. 如果实时数据没取到，对应 voltage/current/power 会按 0 返回
 * 4. 当前代码只支持自研逆变器类型：60419、60420。其它 deviceType 会报错
 */
export const getDeviceDataBySn = (params) => service.get('/meta/device/getDeviceBySnDcSide', { params });

// https://intelligent-test.nahui-newenergy.com/api/meta/device/v2/MB02TAD0000LHRTD0008/detail/getRunningDataAnalyzer?startTs=1774800000000&endTs=1775059199999&fieldIds=1000953,1000997
/**
 * @description 根据设备 SN 获取 PV 直流侧数据
 * @param {Object} params - 请求参数
 * @param {string} params.deviceSn - 设备 SN
 * @param {number} params.startTs - 开始时间戳，单位毫秒
 * @param {number} params.endTs - 结束时间戳，单位毫秒
 * @param {string} params.fieldIds - 字段ID列表，多个ID用逗号分隔
 * @returns {Promise} - 响应结果
 * @example
 * getDeviceRunningDataAnalyzer({
 *   deviceSn: 'NH123456789',
 *   startTs: 1774800000000,
 *   endTs: 1775059199999,
 *   fieldIds: '1000953,1000997'
 * })
 * @note
 */
export const getDeviceRunningDataAnalyzer = (params) => service.get(`/meta/device/v2/${params.deviceSn}/detail/getRunningDataAnalyzer`, { params });

/**
 * @description 根据设备 SN 获取设备能流图数据
 * @param {Object} params - 请求参数
 * @param {string} params.deviceSn - 设备 SN
 * @returns {Promise} - 响应结果
 * @returns {Object} response.data - 能流图数据
 * @returns {string} response.data.timestr - 时间字符串
 * @returns {number} response.data.time - 时间戳
 * @returns {string} response.data.timeZone - 时区
 * @returns {string} response.data.status - 状态
 * @returns {string} response.data.pvPower - 光伏功率
 * @returns {string} response.data.gridPower - 电网功率
 * @returns {string} response.data.batteryPower - 电池功率
 * @returns {string} response.data.batterySoc - 电池电量余量
 * @returns {string} response.data.loadPower - 负载功率
 * @returns {string} response.data.batteryVoltage - 电池电压
 * @returns {string} response.data.batteryType - 电池类型
 * @returns {string} response.data.flowErrorInfo - 能流图错误信息
 * @returns {Array} response.data.flowLines - 能流线列表
 * @returns {number} response.data.ifAcCoupling - 是否 AC 耦合 (0=否，1=是)
 * @returns {string} response.data.inv - 当前 PV 值
 * @returns {string} response.data.outsideInv - 电表 2 的功率
 * @example
 * getDeviceFlowData({
 *   deviceSn: 'NH123456789'
 * })
 * @note
 */
export const getDeviceFlowDataV2 = (params) => service.get(`/meta/device/v2/device/${params.deviceSn}/flow`, { params });

/**
 * @description 根据设备 SN 上传设备设置/平台获取03帧数据能力
 * @param {Object} params - 请求参数
 * @param {string} params.deviceSn - 设备 SN
 * @returns {Promise} - 响应结果
 * @example
 * uploadDeviceSetting({
 *   deviceSn: 'NH123456789',
 * })
 * @note
 */
export const uploadDeviceSetting = (params) => service.get(`/meta/device/control/setting/03/upload`, { params });

/**
 * 设备日志查询（search_after 游标分页，适用于 ES 深度分页）
 * @method GET
 * @param {Object} params
 * @param {string} params.sn - 必传，设备SN
 * @param {number} [params.pageSize=10] - 每页条数
 * @param {number} params.startTs - 必传，开始时间（毫秒时间戳）
 * @param {number} params.endTs - 必传，结束时间（毫秒时间戳）
 * @param {string} [params.functionCode] - 功能码
 * @param {number} [params.searchAfterTime] - 上一页最后一条记录的 time 值，首页不传
 * @param {string} [params.searchAfterId] - 上一页最后一条记录的 _id 值，首页不传
 * @returns {Promise<Object>} 响应数据
 * {
 *   "code": 200,
 *   "message": "success",
 *   "data": {
 *     "pageSize": 10,
 *     "total": 156,
 *     "searchAfterTime": 1719865600000 | null,
 *     "searchAfterId": "avcJY4kBZT4Uq-6K" | null,
 *     "records": [
 *       {
 *         "id": 1,
 *         "reportTime": "设备上报时间（已按电站时区格式化）",
 *         "time": "系统时间（已按电站时区格式化）",
 *         "traceId": "链路追踪ID",
 *         "deviceSn": "设备SN",
 *         "collectorSn": "采集器SN",
 *         "functionCode": "功能码",
 *         "encryptedStr": "加密原始字符串",
 *         "decryptedStr": "解密后字符串"
 *       }
 *     ]
 *   }
 * }
 * @note 查询时间范围不能超过1天（24小时，86,400,000 毫秒）；
 *       当响应中 searchAfterTime/searchAfterId 为 null 时表示已无更多数据，无需继续翻页。
 */
export const getDeviceLog = (params) => service.get('/meta/device/v2/log', { params });
